// @flow
import { get } from './common';
import { handleAPIErrors } from '../sentry-util';

export const fetchPassbook = async (
	{ mobile, startDate, endDate }: { mobile: string, startDate: string, endDate: string },
	session: string
) => {
	try {
		const res = await get(`/customer/wallet/getWalletPassbook`, { user_id: mobile, start_date: startDate, end_date: endDate }, { session });
		const { data = [], count= 0, status = false, msg } = res;
		if (!status) {
			throw new Error(msg || 'Error while fetching passbook');
		}
		return {data, count};
	} catch (error) {
		handleAPIErrors(error, '/customer/wallet/getWalletPassbook', 'GET', { user_id: mobile });
		// console.error(error);
		throw error;
	}
};